import { Box, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { updateInventory, updateInventoryDetail, updateInventoryDetailsModal, updateInventoryModal, updateInventoryform, updateallInventryDetails, updateinventoryEdit } from "../Redux/inventory";
import { useState } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { useGetInventory, useGetInventoryDetails } from "../Components/globalFunctions";

export function InventoryTable() {
    const authToken = localStorage.getItem('authtoken');
    const toast = useRef(null);
    const navigate = useNavigate();
    const edit = useSelector(state => state.inventory.inventoryEdit)
    const inventory = useSelector(state => state.inventory.inventory);
    const inventoryForm = useSelector(state => state.inventory.inventoryForm);
    const supervisors = useSelector(state => state.inventory.supervisors)
    const admins = useSelector(state => state.inventory.admins)
    const customerEngagementAdmins = useSelector(state => state.inventory.customerEngagementAdmins)
    const cashiers = useSelector(state => state.inventory.cashiers)
    const [details, setDetails] = useState([])
    const inventoryLoading = useSelector(state => state.inventory.inventoryLoading);
    const dispatch = useDispatch();
    const getInventeroryDetails = useGetInventoryDetails()
    const getInventerory = useGetInventory()
    
    // Get user role and assigned hubs
    const user_role = localStorage.getItem('role');
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    // Function to check if a hub is assigned to the current user
    const isHubAssigned = (hubId) => {
        if (user_role === 'super_admin') {
            return true; // Super Admin has access to all hubs
        }
        return assignedHubs.includes(hubId);
    };

    useEffect(() => {
        if (inventory.length > 0) {
            console.log("--------------------------------------------", inventory, supervisors)

            const addNamesToArray1 = (inventory, supervisors, admins, customerEngagementAdmins, cashiersList) => {
                return inventory.map(item => {
                    const newItem = { ...item, names: [], adminNames: [], customerEngagementAdminNames: [], cashierNames: [] };

                    newItem.names = item.supervisors
                        .flatMap(superid => supervisors
                            .filter(superv => superv.value === superid)
                            .map(superv => superv.name)
                        );
                    newItem.adminNames = item.admins
                        .flatMap(adminid => admins
                            .filter(admin => admin.value === adminid)
                            .map(admin => admin.name)
                        );
                    newItem.customerEngagementAdminNames = item.customer_engagement_admins
                        .flatMap(ceadminid => customerEngagementAdmins
                            .filter(ceadmin => ceadmin.value === ceadminid)
                            .map(ceadmin => ceadmin.name)
                        );
                    newItem.cashierNames = (item.cashier_ids || [])
                        .flatMap(cashierId => cashiersList
                            .filter(cashier => cashier.value === cashierId)
                            .map(cashier => cashier.name)
                        );

                    // Preserve franchise information
                    newItem.franchise = item.franchise;

                    return newItem;
                });
            };

            // Filter inventory based on user role and assigned hubs
            let filteredInventory = inventory;
            if (user_role === 'supervisor') {
                // For supervisors, show ALL hubs but with different permission levels
                filteredInventory = inventory; 
                console.log("Supervisor sees all inventory:", filteredInventory);
            } else if (user_role === 'customer_engagement_admin') {
                // For customer engagement admin, only show assigned hubs
                filteredInventory = inventory.filter(item => {
                    return assignedHubs.includes(item.value);
                });
            }
            // Super admin and admin see all inventory (no filtering)

            const updatedArray1 = addNamesToArray1(filteredInventory, supervisors, admins, customerEngagementAdmins, cashiers);
            console.log("Updated inventory with franchise data:", updatedArray1);

            setDetails(updatedArray1)
        }
    }, [inventory, supervisors, admins, customerEngagementAdmins, cashiers, inventoryForm, user_role, assignedHubs])

    const accept = async (id) => {
        console.log(id)
        const response = await CustomAxios.delete(`inventory/delete/${id}`, {

        }).then(res => {
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Inventory Deleted Successfully', life: 3000 });
            getInventeroryDetails()
            getInventerory()
        }).catch(err => { console.log(err) });
    }

    const confirmDelete = (item) => {
        console.log(item)
        confirmDialog({
            message: (
                <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
                        <Box>
                            <Typography >Hubname: {item.name}</Typography>
                        </Box>
                    </Box>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>Do you want to delete this Inventory </Typography>
                </Box>
            ),
            header: 'Delete Confirmation',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => accept(item.value),
        });
    };

    const handleViewHub = (item) => {
        // Open the edit modal in view-only mode
        console.log("Viewing hub details:", item);
        
        // Set the form data for viewing
        let rowData = {
            value: item.value,
            place: item.name,
            supervisor_ids: item.supervisors || [],
            admin_ids: item.admins || [],
            customer_engagement_admin_ids: item.customer_engagement_admins || [],
            cashier_ids: item.cashier_ids || [],
            pincodes: item.pincodes || [],
            franchise_id: item.franchise ? item.franchise.id : '',
            hub_setup: item.hub_setup || '',
            hub_link: item.hub_link || '',
            mobileno: item.mobileno || '',
            delivery_fee: item.delivery_fee || '',
            delivery_mini_spent: item.delivery_mini_spent || '',
            delivery_status: item.delivery_status || '',
            self_pickup_waiver: item.self_pickup_waiver || false,
            self_pickup_waiver_percentage: item.self_pickup_waiver_percentage || '',
            shop_open_at: item.shop_open_at || null,
            shop_close_at: item.shop_close_at || null,
            isViewOnly: true
        };
        
        console.log("ViewHub rowData hub_setup:", rowData.hub_setup);
        
        dispatch(updateinventoryEdit(false)); // Set to false to indicate view-only mode
        dispatch(updateInventoryform(rowData));
        dispatch(updateInventoryModal(true)); // Open the modal
    };

    const handleOpen = (row) => {
        // Navigate to edit hub page instead of opening modal
        navigate(`/home/edit_hub/${row.value}`);
    };

    console.log(details)
    return (<Box>
        <Toast ref={toast} />
        <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", paddingBottom: '20px' }}>
            Hub List
            {user_role === 'supervisor' && (
                <Typography component="span" sx={{ fontSize: "12px", fontWeight: "400", color: "gray", fontStyle: "italic", marginLeft: "10px" }}>
                    (Limited Edit)
                </Typography>
            )}
        </Typography>
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Hubname</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Franchise</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Supervisors</TableCell>
                        {user_role === 'super_admin' && (
                            <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Admins</TableCell>
                        )}
                        {user_role === 'super_admin' && (
                            <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Customer Engagement Admins</TableCell>
                        )}
                        {user_role === 'super_admin' && (
                            <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Cashiers</TableCell>
                        )}
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Hub Setup Fields</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Hub Contact No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Address</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {details?.length > 0 ?
                        details?.map((item, ind) => {
                            // console.log("Inventory item with franchise:", item);
                            return (<> {
                                <TableRow key={item.id}>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{ind + 1}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.name}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                                        {item.franchise ? item.franchise.name : 'No Franchise'}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{
                                        item.names.map((name) => (
                                            <Typography>{name}</Typography>
                                        ))}

                                    </TableCell>
                                    {user_role === 'super_admin' && (
                                        <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{
                                            item.adminNames && item.adminNames.length > 0 ? (
                                                item.adminNames.map((name) => (
                                                    <Typography key={name}>{name}</Typography>
                                                ))
                                            ) : (
                                                <Typography sx={{ color: "gray", fontStyle: "italic" }}>No Admins</Typography>
                                            )}
                                        </TableCell>
                                    )}
                                    {user_role === 'super_admin' && (
                                        <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{
                                            item.customerEngagementAdminNames && item.customerEngagementAdminNames.length > 0 ? (
                                                item.customerEngagementAdminNames.map((name) => (
                                                    <Typography key={name}>{name}</Typography>
                                                ))
                                            ) : (
                                                <Typography sx={{ color: "gray", fontStyle: "italic" }}>No Customer Engagement Admins</Typography>
                                            )}
                                        </TableCell>
                                    )}

                                    {user_role === 'super_admin' && (
                                        <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{
                                            item.cashierNames && item.cashierNames.length > 0 ? (
                                                item.cashierNames.map((name) => (
                                                    <Typography key={name}>{name}</Typography>
                                                ))
                                            ) : (
                                                <Typography sx={{ color: "gray", fontStyle: "italic" }}>No Cashiers</Typography>
                                            )}
                                        </TableCell>
                                    )}
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                                        {(() => {
                                            const hubSetup = item?.hub_setup;
                                            
                                            if (!item?.pincodes || item.pincodes.length === 0) {
                                                return <Typography sx={{ color: "gray", fontStyle: "italic" }}>No data</Typography>;
                                            }
                                            
                                            return item.pincodes.map((pin, ind) => {
                                                let displayText = "";
                                                
                                                if (hubSetup === 'radius') {
                                                    // Display inner_radius only
                                                    displayText = pin.inner_radius ? `Inner Radius: ${pin.inner_radius}` : 'No radius set';
                                                } else if (hubSetup === 'radius_and_pincode') {
                                                    // Display both inner_radius and pincode
                                                    const parts = [];
                                                    if (pin.inner_radius) parts.push(`Inner Radius: ${pin.inner_radius}`);
                                                    if (pin.pincode) parts.push(`Pincode: ${pin.pincode}`);
                                                    displayText = parts.length > 0 ? parts.join(', ') : 'No data';
                                                } else if (hubSetup === 'pincode') {
                                                    // Display just pincode
                                                    displayText = pin.pincode || 'No pincode set';
                                                } else if (hubSetup === 'boundary') {
                                                    // Display four latitudes and longitudes
                                                    const boundaryParts = [];
                                                    if (pin.north_latitude && pin.north_longitude) {
                                                        boundaryParts.push(`N: ${pin.north_latitude}, ${pin.north_longitude}`);
                                                    }
                                                    if (pin.south_latitude && pin.south_longitude) {
                                                        boundaryParts.push(`S: ${pin.south_latitude}, ${pin.south_longitude}`);
                                                    }
                                                    if (pin.east_latitude && pin.east_longitude) {
                                                        boundaryParts.push(`E: ${pin.east_latitude}, ${pin.east_longitude}`);
                                                    }
                                                    if (pin.west_latitude && pin.west_longitude) {
                                                        boundaryParts.push(`W: ${pin.west_latitude}, ${pin.west_longitude}`);
                                                    }
                                                    displayText = boundaryParts.length > 0 ? boundaryParts.join(' | ') : 'No boundary set';
                                                } else {
                                                    // Fallback: display pincode if available
                                                    displayText = pin.pincode || 'No data';
                                                }
                                                
                                                return (
                                                    <Typography key={ind} sx={{ mb: ind < item.pincodes.length - 1 ? 1 : 0 }}>
                                                        {(ind + 1) + ". " + displayText}
                                                    </Typography>
                                                );
                                            });
                                        })()}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>{item.mobileno}</TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white", maxWidth: '200px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                        {
                                            item?.pincodes?.map((pin, ind) => (
                                                <Typography key={ind} sx={{ whiteSpace: 'normal', wordBreak: 'break-word', mb: ind < item.pincodes.length - 1 ? 1 : 0 }}>
                                                    {(ind + 1) + ". " + pin.hub_address}
                                                </Typography>
                                            ))}

                                    </TableCell>
                                    <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: "white" }}>
                                        {(() => {
                                            const hubAssigned = isHubAssigned(item.value);
                                            
                                            if (user_role === 'super_admin') {
                                                // Super Admin: Can update and delete all hubs
                                                return (
                                                    <>
                                                        <Tooltip title="Update" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => handleOpen(item)}><EditIcon /></IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Delete" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => confirmDelete(item)}><DeleteOutlineIcon /></IconButton>
                                                        </Tooltip>
                                                    </>
                                                );
                                            } else if (user_role === 'admin') {
                                                if (hubAssigned) {
                                                    // Assigned hubs: Can update only (no delete)
                                                    return (
                                                        <Tooltip title="Update" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => handleOpen(item)}><EditIcon /></IconButton>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    // Non-assigned hubs: Can only view (no edit/delete)
                                                    return (
                                                        <Tooltip title="View Only" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => handleViewHub(item)}><VisibilityIcon /></IconButton>
                                                        </Tooltip>
                                                    );
                                                }
                                            } else if (user_role === 'supervisor') {
                                                // For supervisors, check if the hub is assigned to them using the hub array
                                                const hubAssigned = isHubAssigned(item.value);
                                                
                                                if (hubAssigned) {
                                                    // Assigned hubs: Can edit limited fields (no delete)
                                                    return (
                                                        <Tooltip title="Edit Limited Fields" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => handleOpen(item)}><EditIcon /></IconButton>
                                                        </Tooltip>
                                                    );
                                                } else {
                                                    // Non-assigned hubs: Can only view (no edit/delete)
                                                    return (
                                                        <Tooltip title="View Only" arrow>
                                                            <IconButton sx={{ textTransform: "none" }} onClick={() => handleViewHub(item)}><VisibilityIcon /></IconButton>
                                                        </Tooltip>
                                                    );
                                                }
                                            } else {
                                                // Other roles: View only
                                                return (
                                                    <Tooltip title="View Only" arrow>
                                                        <IconButton sx={{ textTransform: "none" }} onClick={() => handleViewHub(item)}><VisibilityIcon /></IconButton>
                                                    </Tooltip>
                                                );
                                            }
                                        })()}
                                    </TableCell>
                                </TableRow>}</>)
                        })
                        : <TableRow  >
                            {details?.length > 0 && inventoryLoading ? <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={user_role === 'super_admin' ? 10 : 8}>
                                <Box>
                                    <Box sx={{ width: "80%" }}>
                                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                                    </Box>
                                    <Box sx={{ width: "80%" }}>
                                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                                    </Box>
                                    <Box sx={{ width: "80%" }}>
                                        <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                        <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                                    </Box>
                                </Box>
                            </TableCell> :
                                <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={user_role === 'super_admin' ? 10 : 8}>No Inventory Available</TableCell>}
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}